import {
  EmptyState,
  EmptyStateTitle,
  EmptyStateDescription,
  FormattedRelativeTime,
  Link,
  Stack,
  Text,
  Box,
} from '@customerio/pluma-components/react';
import sanitizeHtml from 'sanitize-html';
import { isEmptyString } from '@/utils/string';
import type { ProductUpdate } from './product-updates-types';
import * as styles from './product-updates-list.css';

export interface ProductUpdatesListProps {
  updates: ProductUpdate[];
  onClose: () => void;
}

export function ProductUpdatesList({ updates, onClose }: ProductUpdatesListProps) {
  if (updates.length === 0) {
    return (
      <EmptyState>
        <EmptyStateTitle icon="feature-launch">No new features</EmptyStateTitle>
        <EmptyStateDescription>Check back soon!</EmptyStateDescription>
      </EmptyState>
    );
  }

  return (
    <Stack gap="0" overflowY="auto" className={styles.scrollContainer}>
      {updates.map((update) => {
        const lastUpdate = update.updated !== 0 ? update.updated : update.activated;

        return (
          <Box key={update.id} p="200" className={styles.updateItem}>
            <Stack gap="050">
              <FormattedRelativeTime date={lastUpdate * 1000} size="xs" color="subtle" />
              <Text size="s" weight="semibold" dangerouslySetInnerHTML={{ __html: sanitizeHtml(update.title) }} />
              <Text size="s" color="subtle" dangerouslySetInnerHTML={{ __html: sanitizeHtml(update.body) }} />
              {!isEmptyString(update.linkUrl) && !isEmptyString(update.linkText) ? (
                <Link
                  href={update.linkUrl}
                  variant="primary"
                  isExternal
                  icon="exit"
                  iconPosition="trailing"
                  onClick={onClose}
                >
                  {update.linkText}
                </Link>
              ) : null}
            </Stack>
          </Box>
        );
      })}
    </Stack>
  );
}
